import T from "i18n-react";
import moment from "moment";
import React, { ChangeEvent, useState } from "react";
import DatePicker from "react-date-picker";
import { useHistory } from "react-router-dom";
import { ConsumerUpdate, ConsumerUpdatePreferences } from "../../Api.js";
import { LOGIN } from "../../constants/URL.const";
import { onKeyboardPressHandler } from "../../utils/keyboard";
import { useSnackbarMessages } from "../../yoello-lib/modules/components/snackbar/SnackbarContext";
import Button from "../Widgets/Button";
import Styles from "./styles.module.scss";
import { Checkbox } from "antd";
import "../GroupPage/FilteringPage/filteringPage.module.scss";

/**RFC 5322 Official Standard Email regex */
// eslint-disable-next-line
const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

interface ISignUpProps {
  token: string;
  onAuthenticatedUser: () => void;
}

function Signup({ token, onAuthenticatedUser }: ISignUpProps) {
  const [errors, setErrors] = useState<Record<string, any>>({});
  const [signUpForm, setSignUpForm] = useState<Record<string, any>>({});
  const [showInput, setShowInput] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [marketingPreference, setMarketingPreference] = useState(true);
  const { sendSnackbarMessage } = useSnackbarMessages()!;
  const history = useHistory();

  console.log(errors);
  const validateData = (e: ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name;
    const value = e.target.value;
    const errObj = errors;
    switch (name) {
      case "first_name":
        if (value.match("^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$")) {
          errObj[name] = "";
        } else {
          errObj[name] = T.translate("Login.Errors.IncorrectFormat");
        }
        break;

      case "last_name":
        if (value.match("^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$")) {
          errObj[name] = "";
        } else {
          errObj[name] = T.translate("Login.Errors.IncorrectFormat");
        }
        break;

      case "contact_email":
        const regexValue = emailRegex.test(value);
        if (regexValue !== true) {
          errObj[name] = T.translate("Login.Errors.IncorrectFormat");
        } else {
          errObj[name] = "";
        }
        break;
      default:
        break;
    }
    setErrors(errObj);
  };
  function handleUserInput(event: ChangeEvent<HTMLInputElement>) {
    const name = event.target.name;
    const value = event.target.value;
    const regex = new RegExp(/^\S*$/);
    if (regex.test(value)) {
      validateData(event);
      setSignUpForm((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  }
  const checkValidation = () =>
    signUpForm.dob === "Invalid date" ||
    errors.first_name ||
    errors.last_name ||
    errors.contact_email;
  function changeDOB(time: Date | Date[]) {
    const date = moment(time as Date)
      .locale("en")
      .format("YYYY-MM-DD");
    setSignUpForm((prevState) => ({
      ...prevState,
      dob: date,
    }));
  }
  async function onSignup() {
    console.log(signUpForm);
    const useMarketingPreferences = {
      marketing_email: marketingPreference,
      marketing_sms: marketingPreference,
    };
    if (
      signUpForm.dob === undefined ||
      signUpForm.dob === "Invalid date" ||
      signUpForm.dob.substr(0, 4) > 2050 ||
      signUpForm.dob.substr(0, 4) < 1850
    ) {
      sendSnackbarMessage(
        T.translate("Login.Errors.EnterValidDob") as string,
        "error"
      );
    } else {
      setIsLoading(true);
      try {
        await ConsumerUpdate(signUpForm, token);
        await ConsumerUpdatePreferences(useMarketingPreferences, token);
        onAuthenticatedUser();
      } catch (error) {
        if (error.response) {
          const status = error.response.status;
          if (status === 401 || status === 412) {
            window.localStorage.removeItem("user_token");
            history.push(LOGIN);
          }
        }
        sendSnackbarMessage(
          error?.response?.data?.message ||
            (T.translate("Login.Errors.CreateAccountError") as string),
          "error"
        );
      }
    }
  }
  return (
    <div>
      <div>
        <T.p
          className={Styles.Text1}
          text={{ key: "Login.Texts.BuildYourProfile" }}
        />
        <p className={Styles.Text2}>
          {T.translate("Login.Texts.EnterBasicInfo")}
          <br />
          <strong>{T.translate("Login.Texts.BuildYourProfile")}</strong>{" "}
        </p>
      </div>

      {errors.first_name ? (
        <label className={Styles.InputErrorText}>{errors.first_name}</label>
      ) : null}
      <div
        className={`${Styles.SignUpInputDivs} ${
          errors.first_name ? `${Styles.SignUpInputDivsError} mt-0` : ""
        }`}
        style={{
          marginTop: "10px",
        }}
      >
        <span className="consumer-firstname" />
        <input
          onKeyPress={onKeyboardPressHandler}
          onBlur={validateData}
          type="text"
          className={Styles.SignUpInput}
          placeholder={T.translate("Forms.FirstName") as string}
          value={signUpForm.first_name}
          name="first_name"
          onChange={handleUserInput}
        />
        {errors.first_name ? (
          <img
            className={Styles.ErrorImage}
            src={require("../../imges/ErrorX.svg")}
            alt="Error"
          />
        ) : null}
      </div>
      {errors.last_name ? (
        <label className={Styles.InputErrorText}>{errors.last_name}</label>
      ) : null}
      <div
        className={`${Styles.SignUpInputDivs} ${
          errors.last_name ? `${Styles.SignUpInputDivsError} mt-0` : ""
        }`}
        style={{
          marginTop: "10px",
        }}
      >
        <span className="consumer-lastname" />
        <input
          onKeyPress={onKeyboardPressHandler}
          onBlur={validateData}
          type="text"
          className={Styles.SignUpInput}
          autoComplete="family-name"
          placeholder={T.translate("Forms.LastName") as string}
          name="last_name"
          value={signUpForm.last_name}
          onChange={handleUserInput}
        />
        {errors.last_name ? (
          <img
            className={Styles.ErrorImage}
            src={require("../../imges/ErrorX.svg")}
            alt="Error"
          />
        ) : null}
      </div>
      {showInput ? (
        <div
          className={Styles.SignUpInputDivs}
          style={{
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            paddingLeft: "10px",
          }}
        >
          {errors.dob ? (
            <label className={Styles.InputErrorText}>{errors.dob}</label>
          ) : null}
          {/* <input onKeyPress={onKeyboardPressHandler} autoFocus={true} name="bday" autoComplete="bday" onBlur={this.validateData} type="date" className="SignUpInputDob" onChange={handleSelect} /> */}

          <span className="consumer-calendar" />
          <DatePicker
            onChange={changeDOB}
            value={signUpForm.time}
            maxDate={new Date()}
            dayPlaceholder={T.translate("Forms.DayPlaceHolder") as string}
            monthPlaceholder={T.translate("Forms.MonthPlaceHolder") as string}
            yearPlaceholder={T.translate("Forms.YearPlaceHolder") as string}
            //@ts-ignore
            disableCalendar={true}
            format="dd/MM/yyyy"
            showLeadingZeros={false}
          />
        </div>
      ) : (
        <div
          className={Styles.SignUpInputDivs}
          style={{
            marginTop: "10px",
          }}
        >
          <span className="consumer-calendar" />
          <input
            onKeyPress={onKeyboardPressHandler}
            onFocus={() => setShowInput(true)}
            onClick={() => setShowInput(true)}
            type="text"
            className={Styles.SignUpInput}
            autoComplete="bday"
            placeholder={T.translate("Forms.DateOfBirth") as string}
            value={signUpForm.dob}
          />
        </div>
      )}
      {errors.contact_email ? (
        <label className={Styles.InputErrorText}>{errors.contact_email}</label>
      ) : null}
      <div
        className={`${Styles.SignUpInputDivs} ${
          errors.contact_email ? `${Styles.SignUpInputDivsError} mt-0` : ""
        }`}
        style={{
          marginTop: "10px",
        }}
      >
        <span className="consumer-email" />
        <input
          onKeyPress={onKeyboardPressHandler}
          onBlur={validateData}
          type="text"
          className={Styles.SignUpInput}
          placeholder={T.translate("SharingTexts.Email") as string}
          value={signUpForm.contact_email}
          name="contact_email"
          onChange={handleUserInput}
        />
        {errors.contact_email ? (
          <img
            className={Styles.ErrorImage}
            src={require("../../imges/ErrorX.svg")}
            alt="Error"
          />
        ) : null}
      </div>
      <div>
        <div className={Styles.marketingOptDiv}>
          <Checkbox
            onChange={(e) => setMarketingPreference(!e.target.checked)}
          />
          <p>{T.translate("Login.Texts.MarketingOptText")}</p>
        </div>
      </div>

      <div
        style={{
          marginTop: "-16px",
        }}
      >
        <Button
          iconClassName="consumer-right-arrow"
          className={Styles.ContinueButton}
          isLoading={isLoading}
          disabled={checkValidation()}
          title="Continue"
          onClick={onSignup}
        />
      </div>

      <div>
        <p className={Styles.TermsConditions}>
          {" "}
          {T.translate("Login.Texts.Byregistering")}
          <T.a
            rel="noopener noreferrer"
            href={"https://www.yoello.com/terms-conditions"}
            target="_blank"
            text={{ key: "Login.Texts.Terms" }}
          />
          {T.translate("Login.Texts.AndOur")}
          <T.a
            rel="noopener noreferrer"
            href={"https://www.yoello.com/privacy-policy"}
            target="_blank"
            text={{ key: "Login.Texts.Privacy" }}
          />
        </p>
      </div>
    </div>
  );
}

export default Signup;
